export const enum EGolfMessage {
  HostCommand = 1,
  SetFrame = 51,
  PuckUpdate = 103,
  PuckMove = 104,
}
